import React from 'react'
import Select from 'react-select';
const ItcDetails = () => {
    const basicDutyOpt = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className='card'>
            <div className="card-body">
                <form >
                    <div className="row">

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    ITC Location<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    ITCHS Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Policy Para<span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Policy Year <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                    />
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit">
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit">
                            Close
                        </button>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default ItcDetails